import { useAppState } from '../AppStateProvider';
import { DisabledPageView, DisabledPageViewVariant } from '../components/DisabledPageView';
import type { SettingKeysWithDisabledPage, SettingsAppStorage } from '../domain/settings';
import { ENABLE_TOOLS_KEY, ENABLE_CRM_KEY, ENABLE_GCALENDAR_KEY, ENABLE_GMAIL_KEY } from '../domain/settings';
import UrlService from '../services/UrlService';

const mapUrlToSettingConfig = (
  urlString: string | undefined
): { key: SettingKeysWithDisabledPage; pageVariant: DisabledPageViewVariant } | undefined => {
  const url = UrlService.createEventUrl(urlString);

  if (UrlService.isSalesloftUrl(url)) {
    return { key: ENABLE_TOOLS_KEY, pageVariant: DisabledPageViewVariant.Salesloft };
  }
  if (UrlService.isHubspotUrl(url)) {
    return { key: ENABLE_CRM_KEY, pageVariant: DisabledPageViewVariant.HubSpot };
  }
  if (UrlService.isMicrosoftDynamicsUrl(url)) {
    return { key: ENABLE_CRM_KEY, pageVariant: DisabledPageViewVariant.MicrosoftDynamics };
  }
  if (UrlService.isSalesforceUrl(url) || UrlService.isSalesforceLightningUrl(url)) {
    return { key: ENABLE_CRM_KEY, pageVariant: DisabledPageViewVariant.Salesforce };
  }
  if (UrlService.isOutlookCalendarUrl(url)) {
    return { key: ENABLE_TOOLS_KEY, pageVariant: DisabledPageViewVariant.Calendar };
  }
  if (UrlService.isGoogleCalendarUrl(url)) {
    return { key: ENABLE_GCALENDAR_KEY, pageVariant: DisabledPageViewVariant.Calendar };
  }
  if (UrlService.isGmailUrl(url)) {
    return { key: ENABLE_GMAIL_KEY, pageVariant: DisabledPageViewVariant.Gmail };
  }
  if (UrlService.isGoogleSheetsUrl(url)) {
    return { key: ENABLE_TOOLS_KEY, pageVariant: DisabledPageViewVariant.GoogleSheets };
  }
};

const getDisabledPageView = (url: string | undefined, settingsStorage: SettingsAppStorage) => {
  const settingConfig = mapUrlToSettingConfig(url);

  if (settingConfig && !settingsStorage[settingConfig.key]) {
    return { isDisabledPageVisible: true, disabledPageView: <DisabledPageView settingConfig={settingConfig} /> };
  }

  return { isDisabledPageVisible: false, disabledPageView: null };
};

export const useDisabledPageView = () => {
  const { url, settingsStorage } = useAppState();

  return getDisabledPageView(url, settingsStorage);
};
